import { useContext } from 'react';
import { useStore } from 'zustand/index';

import { ValidationContext, ValidationState } from './validationStore';

export function useValidationStore<T>(selector: (state: ValidationState) => T): T {
  const store = useContext(ValidationContext);
  if (!store) throw new Error('Missing ValidationContext.Provider in the tree');
  return useStore(store, selector);
}
